export default {"src":"/_next/static/media/icon-2-step-auth1.55f8fdf6.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};